import { configureStore, createSlice } from "@reduxjs/toolkit";

// Create a slice of state for the authentication status.
// The actual JWT is stored in an HttpOnly cookie managed by the browser;
// this slice only tracks whether the user is considered logged in.
const tokenSlice = createSlice({
  name: "token",
  initialState: sessionStorage.getItem("isLoggedIn") ? "authenticated" : "",
  reducers: {
    setToken: () => {
      // Mark the user as logged in. The JWT is handled by the browser cookie.
      sessionStorage.setItem("isLoggedIn", "true");
      return "authenticated";
    },
    clearToken: () => {
      // Remove the login indicator when the user logs out.
      sessionStorage.removeItem("isLoggedIn");
      return "";
    },
  },
});

// Export the actions generated by createSlice
export const { setToken, clearToken } = tokenSlice.actions;

// Redux store
const store = configureStore({
  reducer: {
    token: tokenSlice.reducer, // Use the reducer directly
  },
});

export default store;
